import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { PaginationInstance } from 'ngx-pagination';

import { OrdPdtModel } from '@app/models/shoppingmall/order-pdt.model';
import { OverlayLoadingState } from '@app/selectors/overlay-loading.selector';
import { getCateCd, getProducts, getTotalProduct, ProductState } from '@app/selectors/shoppingmall/product.selector';
import { setShowOverlayLoading } from '@app/actions/overlay-loading.action';
import { environment } from '@enviroments/environment';
import { loadProducts, loadTotalProduct, setKeySearch } from '@app/actions/shoppingmall/product.action';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AuthUtil } from '@app/common/util/auth.util';
import { Router } from '@angular/router';

@Component({
    selector: 'shopping-product-list',
    templateUrl: './shopping-product-list.component.html',
    styleUrls: ['./shopping-product-list.component.css']
})
export class ShoppingProductListComponent implements OnInit, OnDestroy {

    subCateCd$ = {} as Subscription;

	products$ = new Observable<OrdPdtModel[]>();
	products: OrdPdtModel[] = [];

	total$ = new Observable<number>();
	total: number = 0;

	cateCd$ = new Observable<string>();
	cateCd: string = '';

	member = AuthUtil.getLoginedInfo();

    pathKind: string = 'PC';

	page: number = 1;
	len: number = 10;

	config: PaginationInstance = {
		id: 'shopping-home-product-list',
		itemsPerPage: this.len,
		currentPage: this.page,
		totalItems: this.total,
	};

    constructor(
        private _overlayLoadingStore: Store<OverlayLoadingState>,
        private _productStore: Store<ProductState>,
        private _deviceService: DeviceDetectorService,
        private _router: Router,
        private changeDetector: ChangeDetectorRef,
    ) {
        this.total$ = this._productStore.select(getTotalProduct);
        this.products$ = this._productStore.select(getProducts);
        this.cateCd$ = this._productStore.select(getCateCd);
    }

    ngOnDestroy(): void {
        let hasValue = this.subCateCd$.closed != undefined
        if (this.subCateCd$ && hasValue) {
            this.subCateCd$.unsubscribe()
        }
    }

    ngOnInit(): void {
        this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: true }));

        this.pathKind = this._deviceService.isDesktop() ? 'PC' : 'PHONE';

        this.total$.subscribe(res => {
            this.total = res;
        });

        this.products$.subscribe(res => {
            this.products = res;
            this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: false }));
        });

        this.cateCd$.subscribe(res => {
            this.cateCd = res;
            this.page = 1;
            this.config.currentPage = 1;
            this.loadTotalProduct();
            this.loadProducts();
        });

        this._productStore.dispatch(setKeySearch({ key: "" }));
    }

    onChangePage(page: number): void {
		this.page = page;
		this.config.currentPage = page;
		this.loadProducts();
	}

    ngAfterContentChecked(): void {
		this.changeDetector.detectChanges();
	}

    private loadTotalProduct(): void {
		this._overlayLoadingStore.dispatch(
			setShowOverlayLoading({ loading: true })
		);
		this._productStore.dispatch(
			loadTotalProduct({ params: this.getParams() })
		);
	}

	private loadProducts(): void {
		this._overlayLoadingStore.dispatch(
			setShowOverlayLoading({ loading: true })
		);
		this._productStore.dispatch(loadProducts({ params: this.getParams() }));
	}

    private getParams(): any {
        let url = this._router.url;
        let tmp = url.split('/');
        let cateCd = tmp[3];

        const params = {
            comId: environment.comId,
            cateCd: cateCd,
            pathKind: this.pathKind,
            key: "",
            page: this.page - 1,
            len: this.len,
            userId: AuthUtil.getUserId()
        }

        return params;
    }


}
